import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const storage = createJSONStorage<boolean>(() => globalThis.sessionStorage);

export const jotaiDevToolsVisibleAtom = atomWithStorage('devtools-jotai', false, storage);
jotaiDevToolsVisibleAtom.debugLabel = 'jotaiDevToolsVisible';

export const queryDevToolsVisibleAtom = atomWithStorage('devtools-query', false, storage);
queryDevToolsVisibleAtom.debugLabel = 'queryDevToolsVisible';

export const routerDevToolsVisibleAtom = atomWithStorage('devtools-router', false, storage);
routerDevToolsVisibleAtom.debugLabel = 'routerDevToolsVisible';
